/* eslint-disable */
import _m0 from "protobufjs/minimal";
import {
  SpotlightOnOff_Enum,
  spotlightOnOff_EnumFromJSON,
  spotlightOnOff_EnumToJSON,
} from "../../../../gen/spotlight_driver/spotlight_on_off";

export const protobufPackage = "skills";

export interface SpotlightActionArgs {
  onOff: SpotlightOnOff_Enum;
}

export interface SpotlightActionResultData {
}

export interface SpotlightActionStateData {
}

function createBaseSpotlightActionArgs(): SpotlightActionArgs {
  return { onOff: 0 };
}

export const SpotlightActionArgs = {
  encode(message: SpotlightActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.onOff !== 0) {
      writer.uint32(8).int32(message.onOff);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpotlightActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpotlightActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.onOff = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpotlightActionArgs {
    return { onOff: isSet(object.onOff) ? spotlightOnOff_EnumFromJSON(object.onOff) : 0 };
  },

  toJSON(message: SpotlightActionArgs): unknown {
    const obj: any = {};
    if (message.onOff !== 0) {
      obj.onOff = spotlightOnOff_EnumToJSON(message.onOff);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpotlightActionArgs>, I>>(base?: I): SpotlightActionArgs {
    return SpotlightActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpotlightActionArgs>, I>>(object: I): SpotlightActionArgs {
    const message = createBaseSpotlightActionArgs();
    message.onOff = object.onOff ?? 0;
    return message;
  },
};

function createBaseSpotlightActionResultData(): SpotlightActionResultData {
  return {};
}

export const SpotlightActionResultData = {
  encode(_: SpotlightActionResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpotlightActionResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpotlightActionResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpotlightActionResultData {
    return {};
  },

  toJSON(_: SpotlightActionResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpotlightActionResultData>, I>>(base?: I): SpotlightActionResultData {
    return SpotlightActionResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpotlightActionResultData>, I>>(_: I): SpotlightActionResultData {
    const message = createBaseSpotlightActionResultData();
    return message;
  },
};

function createBaseSpotlightActionStateData(): SpotlightActionStateData {
  return {};
}

export const SpotlightActionStateData = {
  encode(_: SpotlightActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpotlightActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpotlightActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpotlightActionStateData {
    return {};
  },

  toJSON(_: SpotlightActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpotlightActionStateData>, I>>(base?: I): SpotlightActionStateData {
    return SpotlightActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpotlightActionStateData>, I>>(_: I): SpotlightActionStateData {
    const message = createBaseSpotlightActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
